// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tablesWrapper{
    display:flex;
}

.labelTable {
    display: table;
    width: 549px;
    height: 549px;
    top: 37px;
    left: 618px;
    gap: 0px;
    border-radius: 20px;
    table-layout: fixed;
    border-collapse: collapse;
    border-spacing: 0;
    background-color:#F7F7F7;
    margin-bottom: 10px;
    margin-left: 20px;
}

.saveButton {
    width: 80%;
    margin: 50px auto 50px auto;
    height: 50px;
    font-size: 20px;
    border-radius:30px;
    color:white;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: black;
}

.conflictTable {
    top: 37px;
    left: 618px;
    gap: 0px;
    border-radius: 20px;
    width:270px;
    table-layout: fixed;
    border-collapse: collapse;
    border-spacing: 0;
    background-color:#F7F7F7;
    margin-bottom: 10px;
    margin-left: 20px;
}

.stats {
    width: 25px;
height:20px;
display:flex;
align-items: center;
justify-content: center;
padding: 12px 20px 12px 20px;
gap: 10px;
border-radius: 100px;
border: 1px solid black;
margin: 50px auto auto auto;
}
.labelNameWrapper {
    align-items:center;
    padding: 20px 24px 20px 24px;
}

.RadioButtonWrapper {
    padding: 20px 24px 20px 24px;
text-align: center;
vertical-align: middle;
}

.radioButton {
    width: 25px;
height: 25px;
border-radius: 25px;
border: 2px solid black;
margin:auto;
display:flex;
align-items: center;
justify-content: center;
}

.header {
    font-size: 24px;
    font-weight: 200;
    line-height: 29.71px;
    text-align: center;
    padding: 20px 24px 20px 24px;
    }

    .headerConflictTable {
        font-size: 20px;
        font-weight: 200;
        line-height: 29.71px;
        text-align: center;
        padding: 20px 24px 20px 24px;
        }

.labelName {
    width: 158px;
height: 54px;
top: 167px;
left: 653px;
/* padding: 20px 24px 20px 24px; */
gap: 10px;
border-radius: 100px;
font-size:20px;
display:flex;
align-items: center;
justify-content: center;
background-color: white; 
}

.cursorPointer {
    cursor: pointer;
}

.unclickable{
    pointer-events: none;
    opacity: 0.5;
}

@keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(180deg);
    }
  }


  @keyframes rotateBack {
    from {
      transform: rotate(180deg);
    }
    to {
      transform: rotate(0deg);
    }
  }
  
  .rotate {
    animation: rotate 0.5s linear;
    animation-fill-mode: forwards;
  }

  .rotateBack {
    animation: rotateBack 0.3s linear;
    animation-fill-mode: forwards;
  }


.photoNavigation {
 display: block;
 width: 264px;
 height:auto;
 margin:auto;
}


.arrowBack {
    float:left;
}

.hidden {
    visibility: hidden;   
}

.arrowForward{
    float:right;
}

.image {
    width: 264px;
height: 264px;
top: 180px;
left: 314px;
gap: 0px;
border-radius: 20px;
margin-top: 20px;
}

.filterWrapper {
    display: flex;
    flex-direction: column;
    position:relative;
}

.filter {
    width: 138px;
    height: 48px;
    top: 37px;
    left: 314px;
    /* padding: 12px 20px 12px 20px; */
    gap: 0px;
    border-radius: 100px;
    border: 1px solid black;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 0
}

.dropdown {
    top: 58px;
    width: 138px;
    height:auto;
    border: 1px solid black;
    border-radius: 10px;
    z-index: 100;
    background-color: #F7F7F7;
    position:absolute;
    z-index: 1;
}

.dropdown-item-wrapper {
    width: 100%;
    
}

.dropdown-item-border-bottom {
    border-bottom: 1px solid black;
}


.dropdown-item {
    padding: 12px 20px 12px 20px;
}
   

.filterBox {
    width: 100%;
    height: auto;
    display: grid;
    grid-template-rows: auto auto;
    grid-template-columns: auto auto;
    gap: 10px 10px;
}

.labelWrapper {
    display: flex;
}

table .thead {
    border-bottom: 2px solid black;
}

.selectedRadioButton {
    border: 2px solid lightblue;
}

.selection {
    width: 20px;
height: 20px;
border-radius: 20px;
background-color:lightblue;
}

.statsModalLabelHeader {
    padding-right: 60px;
    text-align: left;
}

.statsModalLabelHeaderCategory {
    padding-right: 15px;
    padding-left:15px;
    text-align: center;
}

.breakdownTable {
    display: flex;

}

.centerTextAline {
    text-align: center;
}

.breakdownMale {
    border-right: 1px solid black;
}

.padding30px {
    padding-left: 15px;
    padding-right: 15px;
}

.borderBottom {
    border-bottom: 1px solid black;
}

.labelsList{
    margin-right: 30px;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/ImageLabel.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,SAAS;IACT,WAAW;IACX,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,WAAW;IACX,QAAQ;IACR,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf,WAAW;AACX,YAAY;AACZ,mBAAmB;AACnB,uBAAuB;AACvB,4BAA4B;AAC5B,SAAS;AACT,oBAAoB;AACpB,uBAAuB;AACvB,2BAA2B;AAC3B;AACA;IACI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC,kBAAkB;AAClB,sBAAsB;AACtB;;AAEA;IACI,WAAW;AACf,YAAY;AACZ,mBAAmB;AACnB,uBAAuB;AACvB,WAAW;AACX,YAAY;AACZ,mBAAmB;AACnB,uBAAuB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,4BAA4B;IAC5B;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,4BAA4B;QAC5B;;AAER;IACI,YAAY;AAChB,YAAY;AACZ,UAAU;AACV,WAAW;AACX,kCAAkC;AAClC,SAAS;AACT,oBAAoB;AACpB,cAAc;AACd,YAAY;AACZ,mBAAmB;AACnB,uBAAuB;AACvB,uBAAuB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;;EAGA;IACE;MACE,yBAAyB;IAC3B;IACA;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,iCAAiC;IACjC,6BAA6B;EAC/B;;;AAGF;CACC,cAAc;CACd,YAAY;CACZ,WAAW;CACX,WAAW;AACZ;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB,aAAa;AACb,UAAU;AACV,WAAW;AACX,QAAQ;AACR,mBAAmB;AACnB,gBAAgB;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,WAAW;IACX,kCAAkC;IAClC,QAAQ;IACR,oBAAoB;IACpB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,8BAA8B;AAClC;;;AAGA;IACI,4BAA4B;AAChC;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf,YAAY;AACZ,mBAAmB;AACnB,0BAA0B;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;;AAEjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".tablesWrapper{\n    display:flex;\n}\n\n.labelTable {\n    display: table;\n    width: 549px;\n    height: 549px;\n    top: 37px;\n    left: 618px;\n    gap: 0px;\n    border-radius: 20px;\n    table-layout: fixed;\n    border-collapse: collapse;\n    border-spacing: 0;\n    background-color:#F7F7F7;\n    margin-bottom: 10px;\n    margin-left: 20px;\n}\n\n.saveButton {\n    width: 80%;\n    margin: 50px auto 50px auto;\n    height: 50px;\n    font-size: 20px;\n    border-radius:30px;\n    color:white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    background-color: black;\n}\n\n.conflictTable {\n    top: 37px;\n    left: 618px;\n    gap: 0px;\n    border-radius: 20px;\n    width:270px;\n    table-layout: fixed;\n    border-collapse: collapse;\n    border-spacing: 0;\n    background-color:#F7F7F7;\n    margin-bottom: 10px;\n    margin-left: 20px;\n}\n\n.stats {\n    width: 25px;\nheight:20px;\ndisplay:flex;\nalign-items: center;\njustify-content: center;\npadding: 12px 20px 12px 20px;\ngap: 10px;\nborder-radius: 100px;\nborder: 1px solid black;\nmargin: 50px auto auto auto;\n}\n.labelNameWrapper {\n    align-items:center;\n    padding: 20px 24px 20px 24px;\n}\n\n.RadioButtonWrapper {\n    padding: 20px 24px 20px 24px;\ntext-align: center;\nvertical-align: middle;\n}\n\n.radioButton {\n    width: 25px;\nheight: 25px;\nborder-radius: 25px;\nborder: 2px solid black;\nmargin:auto;\ndisplay:flex;\nalign-items: center;\njustify-content: center;\n}\n\n.header {\n    font-size: 24px;\n    font-weight: 200;\n    line-height: 29.71px;\n    text-align: center;\n    padding: 20px 24px 20px 24px;\n    }\n\n    .headerConflictTable {\n        font-size: 20px;\n        font-weight: 200;\n        line-height: 29.71px;\n        text-align: center;\n        padding: 20px 24px 20px 24px;\n        }\n\n.labelName {\n    width: 158px;\nheight: 54px;\ntop: 167px;\nleft: 653px;\n/* padding: 20px 24px 20px 24px; */\ngap: 10px;\nborder-radius: 100px;\nfont-size:20px;\ndisplay:flex;\nalign-items: center;\njustify-content: center;\nbackground-color: white; \n}\n\n.cursorPointer {\n    cursor: pointer;\n}\n\n.unclickable{\n    pointer-events: none;\n    opacity: 0.5;\n}\n\n@keyframes rotate {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(180deg);\n    }\n  }\n\n\n  @keyframes rotateBack {\n    from {\n      transform: rotate(180deg);\n    }\n    to {\n      transform: rotate(0deg);\n    }\n  }\n  \n  .rotate {\n    animation: rotate 0.5s linear;\n    animation-fill-mode: forwards;\n  }\n\n  .rotateBack {\n    animation: rotateBack 0.3s linear;\n    animation-fill-mode: forwards;\n  }\n\n\n.photoNavigation {\n display: block;\n width: 264px;\n height:auto;\n margin:auto;\n}\n\n\n.arrowBack {\n    float:left;\n}\n\n.hidden {\n    visibility: hidden;   \n}\n\n.arrowForward{\n    float:right;\n}\n\n.image {\n    width: 264px;\nheight: 264px;\ntop: 180px;\nleft: 314px;\ngap: 0px;\nborder-radius: 20px;\nmargin-top: 20px;\n}\n\n.filterWrapper {\n    display: flex;\n    flex-direction: column;\n    position:relative;\n}\n\n.filter {\n    width: 138px;\n    height: 48px;\n    top: 37px;\n    left: 314px;\n    /* padding: 12px 20px 12px 20px; */\n    gap: 0px;\n    border-radius: 100px;\n    border: 1px solid black;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 0\n}\n\n.dropdown {\n    top: 58px;\n    width: 138px;\n    height:auto;\n    border: 1px solid black;\n    border-radius: 10px;\n    z-index: 100;\n    background-color: #F7F7F7;\n    position:absolute;\n    z-index: 1;\n}\n\n.dropdown-item-wrapper {\n    width: 100%;\n    \n}\n\n.dropdown-item-border-bottom {\n    border-bottom: 1px solid black;\n}\n\n\n.dropdown-item {\n    padding: 12px 20px 12px 20px;\n}\n   \n\n.filterBox {\n    width: 100%;\n    height: auto;\n    display: grid;\n    grid-template-rows: auto auto;\n    grid-template-columns: auto auto;\n    gap: 10px 10px;\n}\n\n.labelWrapper {\n    display: flex;\n}\n\ntable .thead {\n    border-bottom: 2px solid black;\n}\n\n.selectedRadioButton {\n    border: 2px solid lightblue;\n}\n\n.selection {\n    width: 20px;\nheight: 20px;\nborder-radius: 20px;\nbackground-color:lightblue;\n}\n\n.statsModalLabelHeader {\n    padding-right: 60px;\n    text-align: left;\n}\n\n.statsModalLabelHeaderCategory {\n    padding-right: 15px;\n    padding-left:15px;\n    text-align: center;\n}\n\n.breakdownTable {\n    display: flex;\n\n}\n\n.centerTextAline {\n    text-align: center;\n}\n\n.breakdownMale {\n    border-right: 1px solid black;\n}\n\n.padding30px {\n    padding-left: 15px;\n    padding-right: 15px;\n}\n\n.borderBottom {\n    border-bottom: 1px solid black;\n}\n\n.labelsList{\n    margin-right: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
